module.exports = __webpack_public_path__ + "media/audios/kid/lesson_7/audio33-c0cc2dc44bca057576b71532f93f9fc5.m4a";